import Page from 'components/layout/Page';
import { useI18n } from 'hooks/useI18n';
import { Element } from 'react-scroll';
import Benchmark from './components/Benchmark';
import CompaniesSection from './components/CompaniesSection';
import DevelopersSection from './components/DevelopersSection';
import GenderSection from './components/GenderSection';
import MethodologySection from './components/MethodologySection';
import SalariesSection from './components/SalariesSection';
import StateOfTheSectorFooter from './components/StateOfTheSectorFooter';
import StateOfTheSectorHero from './components/StateOfTheSectorHero';

type SectionProps = {
  section: string;
  tooltip: string;
};

const StateOfTheSectorComponent: React.FC = () => {
  //const { locale } = useRouter();
  const { t } = useI18n('state-of-the-sector');

  const sections: SectionProps[] = [
    { section: 'hero', tooltip: t('nav.hero') },
    { section: 'developers', tooltip: t('nav.developers') },
    { section: 'salaries', tooltip: t('nav.salaries') },
    { section: 'companies', tooltip: t('nav.companies') },
    { section: 'gender', tooltip: t('nav.gender') },
    { section: 'methodology', tooltip: t('nav.methodology') }
  ];

  return (
    <Page
      hasScrollTop
      sections={sections}
      customFooter={<StateOfTheSectorFooter />}
    >
      <Element name="inicio" id="hero">
        <StateOfTheSectorHero />
      </Element>
      <Element name="developers" id="developers">
        <DevelopersSection />
      </Element>
      <Element name="salaries" id="salaries">
        <SalariesSection />
      </Element>
      <Benchmark />
      <Element name="companies" id="companies">
        <CompaniesSection />
      </Element>
      <Element name="gender" id="gender">
        <GenderSection />
      </Element>
      <Element name="methodology" id="methodology">
        <MethodologySection />
      </Element>
    </Page>
  );
};

export default StateOfTheSectorComponent;
